<template>
  <div class="grid-view__empty">
    <div class="grid-view__empty-content">
      <i class="grid-view__empty-icon iconoir-search"></i>
      <div class="grid-view__empty-text">
        {{
          search
            ? $t('emptyGridView.noSearchResults')
            : $t('emptyGridView.noFilterResults')
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyGridView',
  props: {
    search: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
